// Register the delegated listener once, even if several sections include this file.
if (!window.__kocTextExpandable) {
window.__kocTextExpandable = true;
document.addEventListener('click', function (e) {
  var btn = /** @type {Element} */ (e.target)?.closest('.text-expandable__toggle');
  if (!btn) return;

  var block = /** @type {HTMLElement} */ (btn.closest('.text-expandable'));
  if (!block) return;

  var short = /** @type {HTMLElement} */ (block.querySelector('.text-expandable__short'));
  var full = /** @type {HTMLElement} */ (block.querySelector('.text-expandable__full'));
  var isExpanded = block.classList.contains('text-expandable--open');

  if (isExpanded) {
    if (short) short.hidden = false;
    if (full) full.hidden = true;
    block.classList.remove('text-expandable--open');
    btn.textContent = block.dataset.labelMore || 'Read more';
    btn.setAttribute('aria-expanded', 'false');
  } else {
    if (short) short.hidden = true;
    if (full) full.hidden = false;
    block.classList.add('text-expandable--open');
    btn.textContent = block.dataset.labelLess || 'Read less';
    btn.setAttribute('aria-expanded', 'true');
  }
});
}
